import { Component } from 'react';
import { ArrowRight } from 'lucide-react';

export class WelcomeErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Welcome page error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#0B2240] flex items-center justify-center px-4">
          <div className="text-center max-w-md">
            <h1 className="font-['Playfair_Display'] text-3xl font-semibold text-white mb-4">
              Something went wrong.
            </h1>
            <p className="text-white/60 mb-8 leading-relaxed">
              We're sorry for the inconvenience. Please refresh the page or contact us directly.
            </p>
            <div className="space-y-3">
              <button
                onClick={() => window.location.reload()}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-[#0B2240] font-semibold bg-[linear-gradient(180deg,#E8D89E_0%,#D4AF37_50%,#B99610_100%)] hover:brightness-110 transition-all"
                data-testid="error-reload-btn"
              >
                Refresh Page
                <ArrowRight className="h-4 w-4" />
              </button>
              <p className="text-white/40 text-sm">
                Or call us at{' '}
                <a data-testid="welcome-error-boundary-a-1" href="tel:7045993355" className="text-[#D4AF37] hover:underline">(704) 599-3355</a>
              </p>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
